
import AboutData from "../components/About/About"

export default function About() {
  return (
    <AboutData/>
  )
}